export default "__VITE_ASSET__a55d1c00__"